document.addEventListener('DOMContentLoaded', function () {
  const productGrid = document.getElementById('ProductGrid');
  const spinner = document.getElementById('spinner'); // Reference to spinner element
  let nextPageUrl = document.querySelector('#Pagination a[rel="next"]')?.href;
  let isLoading = false;

  console.log('Initial Next Page URL:', nextPageUrl);

  // Function to handle "Add to Cart" click event
  function handleAddToCartClick(event) {
    const button = event.target.closest('.add-to-cart-button'); // Adjust the class to your button's class name

    if (button) {
      const productId = button.getAttribute('data-product-id'); // Adjust this based on your data attributes
      console.log('Adding product to cart:', productId);

      // Example of adding the product to the cart (make sure to use the Shopify cart API or similar)
      // Shopify.addItem(productId, 1); // Replace with actual cart adding logic

      // You can also trigger any other actions like showing an animation or updating the cart UI
    }
  }

  async function loadMore() {
    if (!nextPageUrl || isLoading) return;
    isLoading = true;

    // Show spinner before fetching
    spinner.style.display = 'block';

    try {
      const response = await fetch(nextPageUrl);
      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const newItems = html.querySelectorAll('#ProductGrid > li');
      console.log('New Products:', newItems); // Debugging: Log new products

      if (newItems.length > 0) {
        newItems.forEach(item => {
          productGrid.appendChild(item);  // Append new products to the grid
        });
      } else {
        console.log('No new products found.');
      }

      const newNextLink = html.querySelector('#Pagination a[rel="next"]');
      nextPageUrl = newNextLink ? newNextLink.href : null;
      console.log('New Next Page URL:', nextPageUrl);

    } catch (error) {
      console.error('Infinite scroll error:', error);
    }

    // Hide spinner once the request is complete
    spinner.style.display = 'none';
    isLoading = false;
  }

  window.addEventListener('scroll', () => {
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 500) {
      loadMore();
    }
  });

  // Event delegation for Add to Cart buttons
  productGrid.addEventListener('click', handleAddToCartClick);
});
